import config from "./WebIMConfig";
import websdk from "easemob-websdk";
import store from '@/store'
import main from '../../main'
import Cookie from 'vue-cookies'
/*import emedia from "easemob-emedia";
import webrtc from "easemob-webrtc";*/
/*import { Message } from "element-ui";*/
function ack(message) {
  var bodyId = message.id; // 需要发送已读回执的消息id
  var msg = new WebIM.message("read", WebIM.conn.getUniqueId());
  msg.set({
    id: bodyId,
    to: message.from
  });
  WebIM.conn.send(msg.body);
}
// 是否为聊天页面
function is_chat_page(){
  let path = window.location.href;
  // 如果是聊天页面
  if(path.indexOf('chat') != -1 && path.indexOf('chat_list') == -1){
    return true;
  }else{
    return false;
  }
}
// 是否为聊天页面是否可以添加消息条数
function is_chat_addnum(id){
  let path = window.location.href;
  // 如果是聊天页面 并且接受到消息的groupid等于当前聊天的groupid则不添加消息条数
  if(path.indexOf('chat') != -1 && path.indexOf('chat_list') == -1 && store.state.group_id == id){
    return true;
  }else{
    return false;
  }
}
// 初始化IM SDK
var WebIM = {};
WebIM = window.WebIM = websdk;
WebIM.config = config;
WebIM.conn = new WebIM.connection({
  appKey: WebIM.config.appkey,
  isHttpDNS: WebIM.config.isHttpDNS,
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  url: WebIM.config.xmppURL,
  apiUrl: WebIM.config.apiURL,
  isAutoLogin: true,
  heartBeatWait: WebIM.config.heartBeatWait,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isStropheLog: WebIM.config.isStropheLog,
  delivery: WebIM.config.delivery
});
if (!WebIM.conn.apiUrl) {
  WebIM.conn.apiUrl = WebIM.config.apiURL;
}

// 注册监听回调
WebIM.conn.listen({
  // 连接成功回调
  onOpened: function (message) {
    console.log(WebIM.config.appkey);

    WebIM.conn.getRoster({
      success: function (roster) {
        let rosData = []
        for (var i = 0, l = roster.length; i < l; i++) {
          if (roster[i].subscription === 'both') {
            rosData.push(roster[i])
            console.log(rosData)
            // store.dispatch('getFriendsData', rosData)
          } else {
            return
          }
        }
      }
    })
  },
  // 收到文本消息
  onTextMessage: function (message) {
    console.log(message,'文本消息');
    if(message.ext.prescriptStatusType == 3){
      console.log('撤回处方消息');

      for (var i = 0;i < store.state.chats.length; i++) {

        if (store.state.chats[i].ext.orderId == message.ext.orderId) {

          store.state.chats[i].ext.yiche = true;

        }
      }
    }
    if(message.ext.conferenceId){
      store.commit('setHuiId',message.ext.conferenceId)
      message.ext.chatType = ''
    }
    if(message.ext.videoChat){
      store.commit('setVideoDoctor',message.ext.personName)
      store.commit('setVideoing',true)
      store.commit('setVideoGroup',message.to)
      message.ext.chatType = ''
    }
    if(message.ext.videoChatStatus){
      main.v1.$toast.center('对方已取消视频')
      store.commit('setVideoing',false)
      message.ext.chatType = ''
    }
    store.commit('updateChats',message);
    let chat_list = store.state.chat_list;
    chat_list.forEach(v => {
      if(message.to == v.hxgroupid){
        if(!is_chat_addnum(v.hxgroupid) && message.ext.tipStatusType!=2){
          v.message_num = +v.message_num + 1;
        }
        if(message.ext.prescriptStatusType){
          v.message_info = '[治疗方案]'
        }else if (message.ext.tip && message.ext.tipStatusType == 1){
          v.message_info = '[服务结束]'
        }else{
          if(message.ext.tipStatusType!=2){
            v.message_info = message.data;
          }
        }
        v.message_time = new Date().getTime();
      }
    })
    store.dispatch('getChatList',chat_list);
    // 判断是否为聊天页面
    if(is_chat_page()){
      if (message.ext.tip && message.ext.tipStatusType == 1) {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
      setTimeout(() => {
        let appbox = document.getElementById("app");
        console.log(appbox.scrollHeight,'scrollHeight')
        console.log(appbox.clientHeight,'clientHeight')
        if (appbox.scrollHeight > appbox.clientHeight) {
          //设置滚动条到最底部
          appbox.scrollTop = appbox.scrollHeight;
        }
      }, 300);
    }
  },
  // 收到表情信息
  onEmojiMessage: function (message) {
  },
  // 收到联系人订阅请求、处理群组、聊天室被踢解散等消息
  onPresence: function (message) {
  },
  // 处理好友申请
  onRoster: function () {
    WebIM.conn.getRoster({
      success: function (roster) {
        let rosData = []
        for (var i = 0, l = roster.length; i < l; i++) {
          if (roster[i].subscription === 'both') {
            rosData.push(roster[i])
            console.log('处理好友申请')
            console.log(rosData)
            // store.dispatch('getFriendsData', rosData)
          } else {
            return
          }
        }
      }
    })
  },
  onReadMessage: function(message){
    console.log(message,'123456789')
  },
  onAudioMessage: function (message) {
    console.log(message)
    let options = {
      url: message.url,
      headers: { Accept: "audio/mp3" },
      accessToken:Cookie.get('accessToken'),
      onFileDownloadComplete: function (response) {
        let objectUrl = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response);
        message.auurl = objectUrl;
        let chat_list = store.state.chat_list;
        chat_list.forEach(v => {
          if(message.to == v.hxgroupid){
            if(!is_chat_addnum(v.hxgroupid)){
              v.message_num = +v.message_num + 1;
            }
            v.message_info = '[语音]';
            v.message_time = new Date().getTime();
          }
        })
        store.dispatch('getChatList',chat_list)
        store.commit('updateChats',message)
      },
      onFileDownloadError: function () {
        console.log("音频下载失败");
      }
    };
    WebIM.utils.download.call(WebIM.conn, options);
    if(is_chat_page()){
      setTimeout(() => {
        let appbox = document.getElementById("app");
        if (appbox.scrollHeight > appbox.clientHeight) {
          //设置滚动条到最底部
          appbox.scrollTop = appbox.scrollHeight;
        }
      }, 300);
    }
  }, // 收到音频消息
  onPictureMessage: function (message) {
    let chat_list = store.state.chat_list;
    chat_list.forEach(v => {
      if(message.to == v.hxgroupid){
        if(!is_chat_addnum(v.hxgroupid)){
          v.message_num = +v.message_num + 1;
        }
        v.message_info = '[图片]';
        v.message_time = new Date().getTime();
      }
    })
    store.dispatch('getChatList',chat_list)
    store.commit('updateChats',message)
    if(is_chat_page()){
      setTimeout(() => {
        let appbox = document.getElementById("app");
        if (appbox.scrollHeight > appbox.clientHeight) {
          //设置滚动条到最底部
          appbox.scrollTop = appbox.scrollHeight;
        }
      }, 300);
    }
  }, // 收到图片消息
  onLocationMessage: function (message) { console.log('位置') }, // 收到位置消息
  onFileMessage: function (message) { console.log('文件') }, // 收到文件消息
  onVideoMessage: function (message) {
    console.log('视频')
  }, // 收到视频消息
  onInviteMessage: function (message) { console.log('群组'+message) }, // 处理群组邀请
  onOnline: function () { console.log('登录') }, // 本机网络连接成功
  onOffline: function () { console.log('断开链接') }, // 本机网络掉线
  // 失败回调
  onError: function (message) {
    console.log(message)
    /*main.v1.$imConn.close('当前关闭')
    main.v1.$imConn.open({
      apiUrl: WebIM.config.apiURL,
      user: Cookie.get('app_token'),
      pwd:'dy123456app',
      appKey: WebIM.config.appkey,
      success:res=>{

      }
    });*/
  }
});

export default {
  install: function (Vue, options) {
    // console.log(WebIM)
    Object.defineProperty(Vue.prototype, '$imConn', { value: WebIM.conn })
    Object.defineProperty(Vue.prototype, '$rtcCall', { value: WebIM.conn })
  }
}



// WEBPACK FOOTER //
// ./src/utils/plugin/webim.js